import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { MAX_QUANTITY } from "@/lib/cart";
import { money } from "@/lib/money";
export function PreviewNotice() {
  return <p className="commerce-notice">Yes, we’re still in D2C mode. You won’t find us anywhere else.</p>;
}
export function PurchasePreference() {
  const { purchaseType, setPurchaseType } = useCart();
  return <fieldset className="commerce-preference"><legend>Delivery preference</legend>
    <label><input type="radio" name="purchase-type" value="one-time" checked={purchaseType === "one-time"} onChange={() => setPurchaseType("one-time")} /> One-time purchase</label>
    <label><input type="radio" name="purchase-type" value="subscribe" checked={purchaseType === "subscribe"} onChange={() => setPurchaseType("subscribe")} /> Subscribe · Save 15%<small>Monthly delivery preference</small></label>
  </fieldset>;
}
export function CartLines({ editable = false, order }) {
  const cart = useCart();
  const items = order?.items || cart.items;
  return <ul className="commerce-lines">{items.map(item => <li key={`${item.id}-${item.flavor}`}>
    <img src={item.image_url} alt={`LENIS ${item.name} pouch`} width="64" height="96" />
    <div className="commerce-line-details"><Link to={`/product/${item.id}`}>{item.name}</Link><p>{item.flavor} · 1,000 g</p>
      {editable ? <div className="commerce-quantity"><button type="button" aria-label={`Decrease quantity of ${item.name}`} onClick={() => cart.updateQty(item.id,item.flavor,item.quantity-1)}>−</button>
        <span aria-live="polite" aria-label={`Quantity of ${item.name}`}>{item.quantity}</span>
        <button type="button" disabled={item.quantity >= MAX_QUANTITY} aria-label={`Increase quantity of ${item.name}`} onClick={() => cart.updateQty(item.id,item.flavor,item.quantity+1)}>+</button>
        <button className="commerce-remove" type="button" onClick={() => cart.removeItem(item.id,item.flavor)} aria-label={`Remove ${item.name} from cart`}>Remove</button></div> : <p>Quantity: {item.quantity}</p>}
    </div><strong>{money(item.price*item.quantity)}</strong>
  </li>)}</ul>;
}
export function OrderTotals({ order }) {
  const cart = useCart();
  const { subtotal, discount, total } = order || cart;
  return <dl className="commerce-totals" aria-live="polite"><div><dt>Subtotal</dt><dd>{money(subtotal)}</dd></div>
    {discount > 0 && <div><dt>Subscription saving (15%)</dt><dd>−{money(discount)}</dd></div>}
    <div><dt>UK delivery</dt><dd>FREE</dd></div><div className="commerce-total"><dt>Estimated total</dt><dd data-testid="checkout-total">{money(total)}</dd></div>
    <div><dt className="commerce-tax-note">Final taxes and delivery are confirmed when your purchase is arranged with LENIS.</dt><dd /></div></dl>;
}
export function EmptyCart() {
  return <main className="commerce-page"><h1>Your cart is empty</h1><p>Add the plant protein to explore the purchase process.</p><Link className="commerce-button" to="/?section=products">Shop protein</Link></main>;
}


